/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 */

/* ------------------------------------------------------------------
   ESCONDE O "COMPRE JA" — HACE

   O botao de pagamento acelerado leva direto ao checkout, pulando o
   carrinho. Assim o cliente nao ve a escada de beneficios por
   quantidade — trabalha contra o ticket medio.

   Esconder por CSS vale para todos os modelos de uma vez. Para
   reverter, apague este bloco.
------------------------------------------------------------------- */
(function () {
  var css = document.createElement('style');
  css.textContent =
    '.shopify-payment-button,' +
    '.product-form__payment-button,' +
    'shopify-accelerated-checkout,' +
    'shopify-accelerated-checkout-cart{display:none !important}';
  document.head.appendChild(css);
})();

/* ------------------------------------------------------------------
   PARCELAMENTO 3x SEM JUROS — HACE

   O tema mostra "em ate 12x de X" com juros de 21,61% embutidos, e um
   script dentro do theme.min.js recalcula esse valor sempre que o
   cliente troca de cor ou tamanho. Como esse arquivo e minificado e nao
   da para editar com seguranca, corrigimos aqui:

     1. o TEXTO — "em ate 12x de" vira "ou 3x de ... sem juros"
     2. o VALOR — preco dividido por 3, sem juros

   Vale para os dois arquivos de produto de uma vez.

   O bloco fica invisivel ate a correcao, para o cliente nao ver o 12x
   piscar. Um tempo limite revela mesmo se algo falhar.

   Para mudar o numero de parcelas, altere PARCELAS abaixo.
------------------------------------------------------------------- */
(function () {
  var PARCELAS = 3;
  var SUFIXO = ' sem juros';

  var estilo = document.createElement('style');
  estilo.textContent =
    '.parcelamento{visibility:hidden}.parcelamento.hace-ok{visibility:visible}';
  document.head.appendChild(estilo);

  function revelar() {
    document.querySelectorAll('.parcelamento').forEach(function (el) {
      el.classList.add('hace-ok');
    });
  }

  setTimeout(revelar, 2500);

  function moeda(centavos) {
    return 'R$ ' + (centavos / 100)
      .toFixed(2)
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function precoEmCentavos() {
    var el = document.querySelector('.price--large') || document.querySelector('.price');

    if (!el) return 0;

    var txt = el.textContent.replace(/[^\d,]/g, '').replace(',', '.');
    var valor = parseFloat(txt);

    return isNaN(valor) ? 0 : Math.round(valor * 100);
  }

  function corrigirTexto(bloco) {
    bloco.childNodes.forEach(function (no) {
      if (no.nodeType !== 3) return;

      var t = no.nodeValue;

      if (/em\s+at[e\u00e9]\s+\d+x\s+de/i.test(t)) {
        no.nodeValue = t.replace(/em\s+at[e\u00e9]\s+\d+x\s+de/i, 'ou ' + PARCELAS + 'x de');
      }
    });

    if (bloco.textContent.indexOf('sem juros') === -1) {
      var span = bloco.querySelector('span');

      if (span) span.insertAdjacentText('afterend', SUFIXO);
    }
  }

  function corrigirValor() {
    var alvo = document.getElementById('parcela');

    if (!alvo) return;

    var preco = precoEmCentavos();

    if (preco <= 0) return;

    var esperado = moeda(Math.floor(preco / PARCELAS));

    if (alvo.textContent.trim() !== esperado) {
      alvo.textContent = esperado;
    }
  }

  function corrigir() {
    document.querySelectorAll('.parcelamento').forEach(corrigirTexto);
    corrigirValor();
    revelar();
  }

  function iniciarParcela() {
    corrigir();

    var alvo = document.getElementById('parcela');

    if (alvo) {
      new MutationObserver(corrigir).observe(alvo, {
        childList: true, characterData: true, subtree: true
      });
    }

    var preco = document.querySelector('.price--large');

    if (preco) {
      new MutationObserver(corrigir).observe(preco, {
        childList: true, characterData: true, subtree: true
      });
    }

    document.documentElement.addEventListener('variant:changed', function () {
      setTimeout(corrigir, 60);
    });

    document.addEventListener('variant:change', function () {
      setTimeout(corrigir, 60);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarParcela);
  } else {
    iniciarParcela();
  }
})();

/* ------------------------------------------------------------------
   BOTAO FLUTUANTE "VER OPCOES" — HACE

   No celular a primeira tela mostra so a foto. Preco, titulo e botao
   ficam abaixo da dobra, e o sticky nativo do tema so aparece DEPOIS
   que o botao real sai da tela.

   Este botao aparece desde o topo e rola ate a primeira variacao (cor),
   deixando o bloco de variacoes visivel.

   Diz "Ver opcoes" e nao "Adicionar ao carrinho" de proposito:
   adicionar direto levaria o tamanho padrao (PP), e o cliente so
   descobriria no carrinho.

   Some quando o sticky nativo entra em cena ou quando o botao real de
   compra esta visivel.
------------------------------------------------------------------- */
(function () {
  var LARGURA_MAX = 749;
  var TEXTO = 'Ver opções';
  var COR = '#3bae8a';
  var FOLGA = 110;

  if (!document.body.classList.contains('template-product') &&
      !document.querySelector('product-meta')) {
    return;
  }

  if (window.innerWidth > LARGURA_MAX) return;

  var botao, botaoReal, stickyNativo;

  function acharAlvo() {
    return document.querySelector('variant-picker') ||
           document.querySelector('.product-form__option-selector') ||
           document.querySelector('[data-product-add-to-cart-button]');
  }

  function criar() {
    botao = document.createElement('button');
    botao.type = 'button';
    botao.className = 'hace-fab';
    botao.innerHTML = TEXTO +
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.4" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var estilo = document.createElement('style');
    estilo.textContent =
      '.hace-fab{position:fixed;left:14px;right:14px;z-index:60;' +
      'bottom:calc(14px + env(safe-area-inset-bottom));' +
      'display:inline-flex;align-items:center;justify-content:center;gap:7px;' +
      'min-height:50px;padding:0 18px;border:0;border-radius:12px;' +
      'background:' + COR + ';color:#fff;font:inherit;font-size:15px;' +
      'font-weight:800;letter-spacing:.02em;text-transform:uppercase;' +
      'cursor:pointer;box-shadow:0 6px 22px rgba(0,0,0,.18);' +
      'opacity:0;transform:translateY(14px);pointer-events:none;' +
      'transition:opacity .28s ease,transform .28s ease}' +
      '.hace-fab.is-on{opacity:1;transform:none;pointer-events:auto}' +
      '.hace-fab svg{width:16px;height:16px;flex:0 0 auto}' +
      '@media(min-width:' + (LARGURA_MAX + 1) + 'px){.hace-fab{display:none}}';

    document.head.appendChild(estilo);
    document.body.appendChild(botao);

    botao.addEventListener('click', function () {
      var alvo = acharAlvo();

      if (!alvo) return;

      var topo = alvo.getBoundingClientRect().top + window.pageYOffset - FOLGA;

      window.scrollTo({ top: Math.max(0, topo), behavior: 'smooth' });
    });
  }

  function deveMostrar() {
    if (stickyNativo && !stickyNativo.hasAttribute('hidden')) return false;

    if (botaoReal) {
      var r = botaoReal.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) return false;
    }

    return true;
  }

  function avaliar() {
    if (!botao) return;

    botao.classList.toggle('is-on', deveMostrar());
  }

  function iniciarFab() {
    botaoReal = document.querySelector('[data-product-add-to-cart-button]:not(#StickyAddToCart)');
    stickyNativo = document.querySelector('product-sticky-form');

    criar();
    avaliar();

    window.addEventListener('scroll', avaliar, { passive: true });
    window.addEventListener('resize', avaliar);

    if (stickyNativo) {
      new MutationObserver(avaliar).observe(stickyNativo, {
        attributes: true, attributeFilter: ['hidden']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarFab);
  } else {
    iniciarFab();
  }
})();